import { FunctionComponent, TouchEvent, MouseEvent } from 'react'

import cx from 'classnames'
import useTouchStart from 'hooks/useTouchStart'

const NavigationOverlay: FunctionComponent<NavigationOverlayProps> = ({ hideNavigation, isNavigationVisible }) => {
  const handleOnTouchMove = (e: TouchEvent<HTMLElement>): void => { e.preventDefault() }
  const { handleTouchStart } = useTouchStart()

  return (
    <a
      href={undefined}
      key='overlay'
      className={cx(
        'o-30 db absolute top0 right0 w-100 h-100 bg-black z15 pointer',
        { db: isNavigationVisible },
        { dn: !isNavigationVisible }
      )}
      onTouchMove={handleOnTouchMove}
      onTouchStart={handleTouchStart}
      onClick={hideNavigation}
    />
  )
}

interface NavigationOverlayProps {
  hideNavigation: (event: MouseEvent<HTMLElement>) => void
  isNavigationVisible: boolean
}

export default NavigationOverlay
